document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.liv-header'),
    mobileDrawer = header?.querySelector('#livMobileDrawer'),
    overlay = header?.querySelector('.liv-header__overlay');

  if (!header) return;

  const closeNavigation = (isFullClose = true) => {
    header.querySelectorAll('.liv-header__nav-item.is-open').forEach(item => item.classList.remove('is-open'));
    if (isFullClose) {
      header.classList.remove('is-switching');
      overlay?.classList.remove('is-active');
      mobileDrawer?.classList.remove('is-open', 'sub-is-open');
      document.body.classList.remove('menu_visible');
      document.documentElement.classList.remove('liv-no-scroll');
      header.querySelector('#liv-icon-close').style.display = 'none';
      header.querySelector('#liv-icon-menu').style.display = 'block';
    }
  };

  header.addEventListener('click', event => {
    const clickedElement = event.target.closest('button, a, .js-sidebar-tab, .js-sub-trigger'),
      navItem = clickedElement?.closest('.liv-header__nav-item');

    if (clickedElement?.classList.contains('js-desktop-trigger')) {
      if (!navItem?.querySelector('.js-dropdown-content')) return;
      event.preventDefault();
      
      const isAlreadyOpen = navItem.classList.contains('is-open');
      const wasAnyOpen = !!header.querySelector('.liv-header__nav-item.is-open');

      // Add is-switching BEFORE closing old one to catch the transition
      if (!isAlreadyOpen && wasAnyOpen) {
        header.classList.add('is-switching');
      } else if (!isAlreadyOpen) {
        header.classList.remove('is-switching');
      }

      closeNavigation(false);

      if (!isAlreadyOpen) {
        window.dispatchEvent(new CustomEvent('liv:menu:open'));
        navItem.classList.add('is-open');
        overlay?.classList.add('is-active');
        document.body.classList.add('menu_visible');
        document.documentElement.classList.add('liv-no-scroll');
      } else {
        closeNavigation(true);
      }
      return;
    }

    if (clickedElement?.closest('#livMobileToggle')) {
      const isDrawerOpen = mobileDrawer?.classList.toggle('is-open');
      if (isDrawerOpen) {
        window.dispatchEvent(new CustomEvent('liv:menu:open'));
      }
      document.body.classList.toggle('menu_visible', isDrawerOpen);
      document.documentElement.classList.toggle('liv-no-scroll', isDrawerOpen);
      header.querySelector('#liv-icon-menu').style.display = isDrawerOpen ? 'none' : 'block';
      header.querySelector('#liv-icon-close').style.display = isDrawerOpen ? 'block' : 'none';
      if (!isDrawerOpen) closeNavigation(true);
      return;
    }

    if (clickedElement?.classList.contains('js-accordion-trigger')) {
      clickedElement.closest('.liv-header__accordion-item')?.classList.toggle('is-active');
      return;
    }

    if (clickedElement?.classList.contains('js-sub-trigger')) {
      header.querySelector('.liv-header__sub-hd-title').textContent = clickedElement.dataset.title || '';
      const mobileGridData = clickedElement.parentElement?.querySelector('.js-mobile-grid-data');
      if (mobileGridData) header.querySelector('#livSubGrid').innerHTML = mobileGridData.innerHTML;
      mobileDrawer?.classList.add('sub-is-open');
      return;
    }

    if (clickedElement?.classList.contains('liv-header__sub-back')) {
      mobileDrawer?.classList.remove('sub-is-open');
      return;
    }

    if (clickedElement?.classList.contains('js-sidebar-tab')) {
      const isCurrentlyActive = clickedElement.classList.contains('is-active');
      navItem?.querySelectorAll('.js-sidebar-tab, .js-tab-content').forEach(item => item.classList.remove('is-active'));
      if (!isCurrentlyActive) {
        clickedElement.classList.add('is-active');
        navItem?.querySelector(`#${clickedElement.dataset.tab}`)?.classList.add('is-active');
      }
      return;
    }

    const backdropClasses = [
      'liv-header__mega-menu',
      'liv-header__mega-inner',
      'liv-header__mega-main',
      'liv-header__simple-dropdown',
      'liv-header__simple-inner',
      'liv-header__products-grid',
      'js-tab-content',
      'liv-header__overlay'
    ];

    const isBackdropClick = event.target === overlay || backdropClasses.some(cls => event.target.classList.contains(cls));

    if (isBackdropClick) {
      closeNavigation(true);
    }
  });

  window.addEventListener('click', event => {
    if (!event.target.closest('.liv-header')) closeNavigation(true);
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1023) closeNavigation(true);
  });
  window.addEventListener('liv:search:open', () => {
    closeNavigation(true);
  });
});

